<template>
  <table>
    <caption>대상자별 통계</caption>
    <thead class="table_list_head table_list_head_line">
      <tr>
        <th rowspan="3" class="sorting" data-sort="rcpName">이름</th>
        <th rowspan="3" class="sorting" data-sort="rcpGenderAndAge">성별/나이</th>
        <th rowspan="3" class="sorting" data-sort="group">그룹</th>
        <th rowspan="3" class="sorting" data-sort="tid">TID</th>
        <th rowspan="3" class="sorting" data-sort="recentDate">
          최근 이용날짜 (6개월 이내)
        </th>
        <th colspan="11">조회기간별 통계</th>
        <th colspan="7">누적 통계 (최근 6개월, 조회기간 무관)</th>
      </tr>
      <tr>
        <th colspan="2">일반소식</th>
        <th colspan="2">반복소식</th>
        <th>맞춤소식</th>
        <th colspan="2">두뇌톡톡</th>
        <th colspan="2">기억검사</th>
        <th>좋은생각</th>
        <th>마음체조</th>
        <th colspan="4">두뇌톡톡</th>
        <th colspan="3">기억검사</th>
      </tr>
      <tr>
        <th class="sorting" data-sort="newsNormalRequestCount">전송</th>
        <th class="sorting" data-sort="newsNormalReadCount">확인</th>
        <th class="sorting" data-sort="newsRepeatRequestCount">전송</th>
        <th class="sorting" data-sort="newsRepeatReadCount">확인</th>
        <th class="sorting" data-sort="newsCustomRequestCount">전송</th>
        <th class="sorting" data-sort="gameStartCount">호출</th>
        <th class="sorting" data-sort="gameFinalCount">완료</th>
        <th class="sorting" data-sort="dementiaStartCount">호출</th>
        <th class="sorting" data-sort="dementiaFinalCount">완료</th>
        <th class="sorting" data-sort="goodStartCount">호출</th>
        <th class="sorting" data-sort="mindStartCount">호출</th>

        <th class="sorting" data-sort="accumGameAvgScore">평균점수</th>
        <th class="sorting" data-sort="accumGameStartCount">호출</th>
        <th class="sorting" data-sort="accumGameFinalCount">완료</th>
        <th class="sorting" data-sort="accumGameFinalDateCount">완료일수</th>
        <th class="sorting" data-sort="accumDementiaLatestStatus">최근결과</th>
        <th class="sorting" data-sort="accumDementiaStartCount">호출</th>
        <th class="sorting" data-sort="accumDementiaFinalCount">완료</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="rowData in sourceList">
        <td>{{rowData.rcpName}}</td>
        <td>{{rowData.rcpGenderAndAge}}</td>
        <td class="left">{{rowData.group}}</td>
        <td class="left">{{rowData.tid}}</td>
        <td>{{rowData.recentDate}}</td>
        <td>{{rowData.newsNormalRequestCount}}</td>
        <td>{{rowData.newsNormalReadCount}}</td>
        <td>{{rowData.newsRepeatRequestCount}}</td>
        <td>{{rowData.newsRepeatReadCount}}</td>
        <td>{{rowData.newsCustomRequestCount}}</td>
        <td>{{rowData.gameStartCount}}</td>
        <td>{{rowData.gameFinalCount}}</td>
        <td>{{rowData.dementiaStartCount}}</td>
        <td>{{rowData.dementiaFinalCount}}</td>
        <td>{{rowData.goodStartCount}}</td>
        <td>{{rowData.mindStartCount}}</td>

        <td>{{rowData.accumGameAvgScore}}</td>
        <td>{{rowData.accumGameStartCount}}</td>
        <td>{{rowData.accumGameFinalCount}}</td>
        <td>{{rowData.accumGameFinalDateCount}}</td>
        <td>{{rowData.accumDementiaLatestStatus}}</td>
        <td>{{rowData.accumDementiaStartCount}}</td>
        <td>{{rowData.accumDementiaFinalCount}}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    sourceList: Array
  }
};
</script>

<style>
</style>